function ArrowLeft() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <title>arrow left</title>
      <g>
        <path
          d='M17.9167 10H2.5H2.91667'
          stroke=''
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='square'
        />
        <path
          d='M8.33333 15.8333L2.5 9.99996L8.33333 4.16663'
          stroke=''
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='square'
        />
      </g>
    </svg>
  )
}

export default ArrowLeft
